import { useState, useEffect } from 'react';
import { Container, Typography, Stack, Box, CircularProgress } from '@mui/material';
import { KantorForm } from '../../../sections/@dashboard/kantor';
import { axiosPrivate } from '../../../common/axiosPrivate';

const EditKantorPage = ({id, handleCloseModal, handleUpdateTable}) => {
  const [pageLoading, setPageLoading] = useState(true);
  const [data, setData] = useState(null);


  useEffect(() => {
    setPageLoading(true);
      axiosPrivate.get(`/kantor/${id}`)
      .then((response) => setData(response?.data))
      .catch((error) => console.log(error?.response))
      .finally(() => setPageLoading(false));
  }, [id]);

  return (
    <>
      {pageLoading ? (
        <Box
          sx={{
            flexGrow: 1
          }}
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={"100%"}
          width={"100%"}
        >
          <CircularProgress />
        </Box>) : (
          <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Ubah Kantor
            </Typography>
          </Stack>
          <KantorForm
            data={data}
            handleCloseModal={handleCloseModal}
            handleUpdateTable={handleUpdateTable}
          />
        </Container>
        )}
    </>
  );
};
  
export default EditKantorPage;
